import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export function getButtonSize(size) {
    switch (size) {
        case 'xs':
            return css `
        padding: ${pxToRem(2)} ${pxToRem(8)};
        height: ${pxToRem(24)};
        line-height: ${pxToRem(24)};
        gap: ${pxToRem(6)};
        font-size: ${themeGet('fontSize.small')};

        [data-icon='falcon'] {
          width: ${pxToRem(13)};
          height: ${pxToRem(13)};
        }
      `;
        case 'small':
            return css `
        padding: ${pxToRem(5)} ${pxToRem(12)};
        height: ${pxToRem(32)};
        line-height: ${pxToRem(32)};
        gap: ${pxToRem(6)};
      `;
        case 'large':
            return css `
        padding: ${pxToRem(13)} ${pxToRem(20)};
        height: ${pxToRem(48)};
        line-height: ${pxToRem(48)};
      `;
        case 'medium':
        default:
            return css `
        padding: ${pxToRem(9)} ${pxToRem(16)};
        height: ${pxToRem(40)};
        line-height: ${pxToRem(40)};
      `;
    }
}
